export var PnCameraStatus;
(function (PnCameraStatus) {
    PnCameraStatus["Success"] = "success";
    PnCameraStatus["Error"] = "error";
    PnCameraStatus["Blocked"] = "blocked";
})(PnCameraStatus || (PnCameraStatus = {}));
